exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background-position:center -50px;background-repeat:no-repeat;background-size:inherit}.push-footer{display:none}.NewInfo{display:table;width:800px;margin:0 auto;text-align:center}.NewInfo .Item{display:block;float:left;width:100%}.NewInfo .Item>*{display:block}.NewInfo .ImageContainer{display:table;width:100%}.NewInfo .ImageContainer>span{display:table-cell;vertical-align:middle}.NewInfo .Image{display:block;max-width:100%;margin:0 auto}.Dots{display:table;margin:10px auto}.Dot{float:left;display:block;width:10px;height:10px;margin-right:30px;border-radius:50%;-webkit-border-radius:50%;-moz-border-radius:50%;color:transparent;background-color:#666}.Dot:last-child{margin-right:0}.Dot.Selected{background-color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules?sourceMap!./vendor/sections/home/home.useable.css
// module id = 727
// module chunks = 0